import { createReducer, on } from '@ngrx/store';

import { fetchUserPermissionsForProjectSuccess } from './permission.actions';
import { PermissionSliceState } from './permission.state';

export const permissionReducer = createReducer<PermissionSliceState>(
	new PermissionSliceState(),
	on(fetchUserPermissionsForProjectSuccess, (state, action) =>
		state.setPermissionList(action.permissions)
	)
);
